import React from "react";
import { Tag } from "antd";
import { StopOutlined, SyncOutlined } from "@ant-design/icons";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

import { BatchStatus } from "models";

interface IBatchNIBSSProps {
  status: BatchStatus;
}

const BatchNIBSS: React.FC<IBatchNIBSSProps> = ({ status }) => {
  return (
    <React.Fragment>
      {status?.toLowerCase() === "successful" ? (
        <Tag
          color="success"
          icon={<CheckCircleOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status?.toLowerCase()}
        </Tag>
      ) : status?.toLowerCase() === "processing" ? (
        <Tag
          color="blue"
          icon={<SyncOutlined spin />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status?.toLowerCase()}
        </Tag>
      ) : status?.toLowerCase() === "badrequest" ? (
        <Tag
          color="error"
          icon={<CloseCircleOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          bad request
        </Tag>
      ) : status?.toLowerCase() === "not treated" ? (
        <Tag
          color="magenta"
          icon={<StopOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : (
        <Tag
          color="default"
          style={{
            paddingRight: 5,
            paddingLeft: 5,
            textAlign: "center",
            display: status ? "inline" : "none",
          }}
        >
          {status?.toLowerCase()}
        </Tag>
      )}
    </React.Fragment>
  );
};

export default BatchNIBSS;
